import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const InboundDeliveriesQuery = graphql(/* GraphQL */ `
  query inboundDeliveries(
    $offset: Int
    $limit: Int
    $sort: SortInput
    $plannedDeliveryDateFilter: DateTime
    $plannedDeliveryDateFilterMatch: DateTimeFilterMatchEnum
  ) {
    inboundDeliveries(
      offset: $offset
      limit: $limit
      sort: $sort
      plannedDeliveryDateFilter: $plannedDeliveryDateFilter
      plannedDeliveryDateFilterMatch: $plannedDeliveryDateFilterMatch
    ) {
      ...InboundDeliveryOverviewPaged
    }
  }
`);
